import { Collapse, CollapseProps } from "antd";
import Slide from "react-reveal/Slide";

const faq: CollapseProps["items"] = [
  {
    key: "1",
    label: "What types of businesses benefit from this inventory software?",
    children: (
      <p className="leading-8 text-gray-600">
        SupaRecords is built for retail stores, supermarkets, pharmacies,
        manufacturers, wholesalers, distributors, warehouses, restaurants,
        hotels, and e-commerce businesses. Whether you manage one location or
        multiple branches, the system scales with your operations.
      </p>
    ),
  },
  {
    key: "2",
    label: "Can I manage multiple warehouses and branches?",
    children: (
      <p className="leading-8 text-gray-600">
        Yes. You can monitor inventory, transfers, purchases, and stock levels
        across multiple warehouses and branches from a single centralized
        dashboard in real time.
      </p>
    ),
  },
  {
    key: "3",
    label: "How does the system prevent stock shortages?",
    children: (
      <p className="leading-8 text-gray-600">
        SupaRecords automatically monitors stock quantities and sends alerts
        when products reach their reorder level. This helps you avoid stockouts
        while reducing unnecessary overstocking.
      </p>
    ),
  },
  {
    key: "4",
    label: "Can small businesses use SupaRecords?",
    children: (
      <p className="leading-8 text-gray-600">
        Absolutely. Our platform is designed for startups, SMEs, and enterprise
        organizations. You can start small and upgrade your plan as your
        business grows.
      </p>
    ),
  },
  {
    key: "5",
    label: "What reports are available?",
    children: (
      <p className="leading-8 text-gray-600">
        Generate detailed reports including inventory valuation, stock movement,
        sales performance, purchases, customer balances, supplier activity,
        profit analysis, and financial summaries.
      </p>
    ),
  },
  {
    key: "6",
    label: "How secure is my business data?",
    children: (
      <p className="leading-8 text-gray-600">
        Your data is protected with secure cloud infrastructure, encrypted
        communication, automated backups, and role-based access control to keep
        your business information safe.
      </p>
    ),
  },
  {
    key: "7",
    label: "How do I get started?",
    children: (
      <p className="leading-8 text-gray-600">
        Simply create your account, choose a pricing plan, and begin managing
        your inventory immediately. Our onboarding team is available to assist
        with setup, migration, and staff training whenever needed.
      </p>
    ),
  },
];

const InventoryFaqComp = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24">

      {/* Background */}

      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-red-100 blur-[140px]" />

      <div className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-orange-100 blur-[150px]" />

      <div className="relative max-w-5xl mx-auto px-6">

        {/* Heading */}

        <Slide bottom>

          <div className="text-center">

            <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-5 py-2">

              <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />

              <span className="text-sm font-semibold text-red-600">
                Frequently Asked Questions
              </span>

            </div>

            <h2 className="mt-8 text-5xl lg:text-6xl font-black leading-tight text-slate-900">

              Everything You Need

              <span className="block bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">

                To Know

              </span>

            </h2>

            <p className="mt-8 text-lg leading-8 text-gray-600">

              Have questions? Here are the answers to the most common questions
              about SupaRecords Inventory & Accounting Software.

            </p>

          </div>

        </Slide>

        {/* FAQ */}

        <Slide bottom>

          <div className="mt-16 rounded-[36px] border border-gray-200 bg-white p-4 shadow-[0_30px_80px_rgba(0,0,0,.08)]">

            <Collapse
              accordion
              ghost
              items={faq}
              expandIconPosition="end"
              className="modern-faq"
            />

          </div>

        </Slide>

        {/* Bottom CTA */}

        <Slide bottom>

          <div className="mt-20 rounded-[36px] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 p-10 text-center text-white">

            <h3 className="text-4xl font-black">

              Still Have Questions?

            </h3>

            <p className="mt-4 text-lg opacity-90">

              Our support team is ready to help you choose the perfect solution
              for your business.

            </p>

            <a
              href="https://admin.suparecords.ng/auth/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex rounded-2xl bg-white px-10 py-4 font-semibold text-red-600 transition hover:scale-105"
            >
              Get Started →
            </a>

          </div>

        </Slide>

      </div>
    </section>
  );
};

export default InventoryFaqComp;